import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  key: null,
  phoneNumber: null,
  userData: null,
  isAuthenticated: false
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuthData: (state, action) => {
      const { key, phoneNumber } = action.payload;
      state.key = key;
      state.phoneNumber = phoneNumber;
      state.isAuthenticated = true;
    },
    setUserData: (state, action) => {
      state.userData = action.payload;
    },
    logout: (state) => {
      return initialState;
    }
  }
});

export const { setAuthData, setUserData, logout } = authSlice.actions;

export default authSlice.reducer; 